/**
 * @typedef {Object} MessageObject
 * @property {string} message
 * @property {Uint8Array} senderViewPublicKey
 * @property {number} timestamp
 */

/**
 * Creates a new MessageObject.
 * 
 * @param {Object} params
 * @param {string} params.message
 * @param {Uint8Array} params.senderViewPublicKey
 * @param {number} params.timestamp
 * @returns {MessageObject}
 */
export function createMessageObject({ 
  message, 
  messageId, 
  messageType, 
  receiverViewPublicKey, 
  senderViewPublicKey, 
  totalFeeLamports,
  timestamp, 
}) {
  return { 
    message, 
    messageId,
    messageType, 
    receiverViewPublicKey, 
    senderViewPublicKey, 
    totalFeeLamports: Number(totalFeeLamports),
    timestamp, 
    read: false, 
  };
}